import axios from "axios";

const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("MGL_TOKEN");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (response?.status === 401) {
      localStorage.removeItem("MGL_TOKEN");
      // window.location.reload();
    } else if (response?.status === 404) {
      //Show not found
    }

    throw error;
  }
);

export default axiosClient;
